import React, { Fragment } from 'react'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import useTextfield from './useTextfield'
import { omit } from 'lodash'
import { TextfieldViewProps, MyTextfieldProps } from './textfieldType'
import { Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

let TextfieldView: React.FC<TextfieldViewProps> = ({
    handleValueChange,
    onEnter,
    field,
    required,
    maxLength,
    min,
    materialInputProps = {},
    type,
    icon,
    defaultValue,
    resetButtom = false,
    onBlur,
    rowsMin = 1,
    error = false,
    fontSize,
    ...other
}) => {
    const { input, meta } = field
    const isError = (meta.error && meta.invalid && meta.touched) || error ? true : false
    const classes = useStyles(isError)
    const getLabel = () => {
        // const isDisable = materialInputProps?.disabled
        const myLabel = required ? (
            <Grid container className={classes.label}>
                <Grid item>
                    {materialInputProps.label || ''}{' '}
                    <label style={{ color: 'red' }}>{materialInputProps.label ? `*` : ''}</label>
                </Grid>
            </Grid>
        ) : (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{materialInputProps.label || ''}</Typography>
                </Grid>
            </Grid>
        )

        return <Typography variant={'subtitle2'}>{myLabel}</Typography>
    }

    return (
        <FormControl
            style={{
                width: '100%',
                minHeight: resetButtom ? '0px' : materialInputProps.multiline ? '176px' : '108px',
            }}
        >
            {getLabel()}
            <TextField
                {...input}
                {...omit(materialInputProps, ['inputProps', 'InputProps', 'rowsMax', 'required', 'label'])}
                autoComplete="off"
                defaultValue={defaultValue}
                variant="outlined"
                required={required ? true : false}
                size={materialInputProps.size || 'small'}
                error={isError} //{!materialInputProps?.disabled && meta.error && meta.touched ? true : false}
                inputProps={{
                    ...materialInputProps?.inputProps,
                    maxLength: maxLength,
                    min: min,
                    rowsMin: rowsMin,
                    style: {
                        fontSize: fontSize ?? 17,
                        lineHeight: 2,
                        overflow: 'auto',
                        height: fontSize ? '20px' : '',
                    },
                }}
                // InputLabelProps={{
                //     shrink: true,
                //     startAdornment: (
                //         <InputAdornment position="start">
                //             <Visibility />
                //         </InputAdornment>
                //     ),
                // }}

                InputProps={{
                    classes: {
                        root: classes.inputRoot,
                        disabled: classes.disabled,
                    },
                    endAdornment: <Fragment>{icon && icon}</Fragment>,
                }}
                onChange={(e) => {
                    const value = e.target.value ? e.target.value : null
                    input.onChange(value)
                    handleValueChange && handleValueChange(e.target.value)
                }}
                onKeyPress={(e) => {
                    if (e.charCode === 13) {
                        if (onEnter) {
                            onEnter()
                        }
                    }
                }}
                type={type}
                onBlur={(e) => onBlur && onBlur(e.target.value)}
            />
            <FormHelperText className={classes.errorText}>
                {/* {!materialInputProps?.disabled && meta.error && meta.touched && meta.error} */}
                {isError && meta.error}
            </FormHelperText>
        </FormControl>
    )
}

let MyTextfield: React.FC<MyTextfieldProps> = ({
    handleValueChange,
    onEnter,
    name,
    required,
    validates,
    maxLength,
    min,
    isDraftNotRequire,
    rowsMin = 1,
    fontSize,
    ...others
}) => {
    const myInput = useTextfield({
        name,
        required,
        validates,
        isDraftNotRequire,
        fontSize,
    })
    return (
        <TextfieldView
            maxLength={maxLength}
            min={min}
            required={required}
            rowsMin={rowsMin}
            handleValueChange={handleValueChange}
            onEnter={onEnter}
            fontSize={fontSize}
            {...myInput}
            {...others}
        />
    )
}

export default MyTextfield

const useStyles = makeStyles((theme) => ({
    label: {
        // fontWeight: 'bold',
        marginBottom: 10,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
        // fontSize: '16px',
    },
    errorText: {
        // fontFamily: 'prompt',
        fontSize: '12px',
        color: '#ff4d4f',
    },
    inputRoot: {
        '&$disabled': {
            color: '#000000',
            backgroundColor: '#F0F0F0C6',
        },
        borderRadius: '8px',
    },
    disabled: {},
}))
